import { render } from "./ProductIndex.vue?vue&type=template&id=416554e8&scoped=true"
import script from "./ProductIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductIndex.vue?vue&type=script&setup=true&lang=js"

import "./ProductIndex.vue?vue&type=style&index=0&id=416554e8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416554e8"],['__file',"resources/js/modules/product-mapping-tool/components/ProductIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "416554e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('416554e8', __exports__)) {
    api.reload('416554e8', __exports__)
  }
  
  module.hot.accept("./ProductIndex.vue?vue&type=template&id=416554e8&scoped=true", () => {
    api.rerender('416554e8', render)
  })

}


export default __exports__